export enum TextSearchType {
    Activity = 1,
    City = 2,
    CategoryInCity = 3,
    Unknown = 99,
}

export const MapTextSearchTypeIdToText: Record<TextSearchType, string> = {
    [TextSearchType.Activity]: 'activity',
    [TextSearchType.City]: 'city',
    [TextSearchType.CategoryInCity]: 'categoryInCity',
    [TextSearchType.Unknown]: 'unknown',
};

export enum RecentSearchType {
    Activity = 'activity',
    City = 'city',
}
